// extracted by mini-css-extract-plugin
module.exports = {"spacer":"styles_spacer__39GAc"};